export default __webpack_public_path__ + "static/Tek_Leggings-36100967f7a6645437a9928c0104cd6e.png";